import dayjs, { Dayjs } from "dayjs";

import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "America/New_York";

interface Discount {
  discountCode: string;
  discountPercentage?: number;
  freeShipping?: boolean;
  expires: Dayjs;
}

const DISCOUNTS: { [discountCode: string]: Discount } = {
  WELCOME: {
    discountCode: "WELCOME",
    discountPercentage: 10,
    expires: dayjs.tz("2024-12-02 23:59:59", TZ),
  },
  FRIENDSQUAD: {
    discountCode: "FRIENDSQUAD",
    discountPercentage: 15,
    expires: dayjs.tz("2024-12-02 23:59:59", TZ),
  },
  MAYTRAVEL2025: {
    discountCode: "MAYTRAVEL2025",
    freeShipping: true,
    expires: dayjs.tz("2025-05-19 23:59:59", TZ),
  },
  PRINTPARTY: {
    discountCode: "PRINTPARTY",
    discountPercentage: 10,
    expires: dayjs.tz("2026-08-30 23:59:59", TZ)
  }
};

export const getDiscount = (code: string) => {
  const discount = DISCOUNTS[code];
  if (!discount || dayjs().isAfter(discount.expires)) {
    return null;
  }

  return discount;
};
